// frontend/src/services/imagemPerfil.js
//
// Prepara a foto de perfil NO NAVEGADOR antes de enviar: confere o tipo, corrige a rotacao de fotos de celular, recorta o quadrado do
// centro, reduz para 256x256 e devolve um JPEG pequeno (data URL). O servidor confere tudo de novo, entao isto e so conforto e economia.

export const TIPOS_FOTO = ['image/jpeg', 'image/png', 'image/webp'];
export const FOTO_MAX_ARQUIVO = 10 * 1024 * 1024; // 10 MB: o que a pessoa pode escolher (a foto enviada fica com poucas dezenas de KB)
export const FOTO_LADO = 256;
export const FOTO_MIN_LADO = 32;
const ALVO_BYTES = 250 * 1024; // folga abaixo do limite de 300 KB do servidor

function falha(mensagem) {
  const erro = new Error(mensagem);
  erro.amigavel = true;
  return erro;
}

function abrirComImage(arquivo) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(arquivo);
    const img = new Image();
    img.onload = () => { URL.revokeObjectURL(url); resolve({ fonte: img, largura: img.naturalWidth, altura: img.naturalHeight, liberar() {} }); };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('imagem ilegivel')); };
    img.src = url;
  });
}

async function abrir(arquivo) {
  if (typeof createImageBitmap === 'function') {
    try {
      const bmp = await createImageBitmap(arquivo, { imageOrientation: 'from-image' });
      return { fonte: bmp, largura: bmp.width, altura: bmp.height, liberar() { if (bmp.close) bmp.close(); } };
    } catch (e) { /* tenta o outro caminho */ }
  }
  return abrirComImage(arquivo);
}

export async function prepararImagem(arquivo, opcoes) {
  const lado = (opcoes && opcoes.lado) || FOTO_LADO;
  if (!arquivo || !TIPOS_FOTO.includes(arquivo.type)) throw falha('Escolha uma foto JPG, PNG ou WebP.');
  if (arquivo.size > FOTO_MAX_ARQUIVO) throw falha('A foto é grande demais (máximo 10 MB). Escolha uma imagem menor.');

  let aberta;
  try { aberta = await abrir(arquivo); } catch (e) { throw falha('Não consegui abrir essa imagem. Tente outro arquivo.'); }
  try {
    const menor = Math.min(aberta.largura, aberta.altura);
    if (!menor || menor < FOTO_MIN_LADO) throw falha('A foto é pequena demais. Escolha uma imagem de pelo menos ' + FOTO_MIN_LADO + ' pixels.');
    const saida = Math.min(lado, menor);
    const canvas = document.createElement('canvas');
    canvas.width = saida;
    canvas.height = saida;
    const ctx = canvas.getContext('2d');
    if (!ctx) throw falha('Este navegador não consegue preparar a foto. Tente outro navegador.');
    ctx.fillStyle = '#ffffff'; // PNG com fundo transparente vira fundo branco no JPEG
    ctx.fillRect(0, 0, saida, saida);
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(aberta.fonte, (aberta.largura - menor) / 2, (aberta.altura - menor) / 2, menor, menor, 0, 0, saida, saida);
    for (const qualidade of [0.85, 0.7, 0.55]) {
      const url = canvas.toDataURL('image/jpeg', qualidade);
      const bytes = Math.floor(((url.length - url.indexOf(',') - 1) * 3) / 4);
      if (url.startsWith('data:image/jpeg') && bytes <= ALVO_BYTES) return url;
    }
    throw falha('Não consegui reduzir a foto o bastante. Escolha outra imagem.');
  } finally {
    aberta.liberar();
  }
}
